import AnalyticsEvent from './AnalyticsEvent';
import { documentReady } from '../../global/helper';
import { logError } from '@/js/utils/utils';
import type GaItemList from './GaItemList';

export default class ShareLinkAnalytics extends AnalyticsEvent<Pick<GaItemList, 'item_id'>> {
	fireShareLink(): void {
		super.fireGoogleAnalyticsEventOrAddListener('share');
		this.alertFaultyShareData(this.items);
	}

	fireShareLinkDomReady(): void {
		documentReady(() => {
			this.fireShareLink();
		});
	}

	static createInstance(itemId: string): ShareLinkAnalytics {
		return new ShareLinkAnalytics({
			item_id: itemId,
		});
	}

	alertFaultyShareData(itemList: GaItemList) {
		if (!itemList?.item_id) {
			const err = new Error('share-event data "item_id" prop is empty');
			logError('ShareLinkAnalytics', err, { key: 'itemList', value: JSON.stringify(itemList) });
		}
	}
}
